export default "__VITE_ASSET__CfAQl$Or__"